<template>
  <IframeCmp type="119" />
</template>

<script>
import IframeCmp from './cmp/IframeCmp';

export default {
  // 应收趋势
  name: 'AccountsReceivableTrend',
  components: {
    IframeCmp
  },
  data() {
    return {

    };
  }
};
</script>

<style scoped></style>
